import React from 'react';
import classnames from 'classnames';
import s from './PlaceholderBlock.scss';
const PlaceholderBlock = ({ className, width, height, children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames(s['root'], className)
    }, children);
};
PlaceholderBlock.displayName = 'PlaceholderBlock';
export default PlaceholderBlock;

//# sourceMappingURL=PlaceholderBlock.js.map